import { dataCheckApi } from "@/shared/apis";

export const firstTwoDigitsNotNumericAndDifferentBE = /^(?!\d{2})(?!BE).*/;

export async function validateVAT(vat: string): Promise<boolean> {
    if (!vat || firstTwoDigitsNotNumericAndDifferentBE.test(vat)) {
        return true;
    }
    return dataCheckApi.queryCheckBelgianVAT(vat);
}
